// See: backend/docs/arvento-telemetry.md §11
// TrackVehiclesPage'in koşullu Telemetri sekmesinin içeriği.
// Şimdilik tek görünüm (Canlı Harita) olduğu için alt-sekme sarmalayıcısı yok.
// İleride (Detay, Driver Scorecard, Reports, Alerts, Replay) eklenince Tabs geri gelir.

import React from "react";
import LiveFleetMap from "./LiveFleetMap";

const Telemetry = () => {
  return <LiveFleetMap />;
};

export default Telemetry;
